<template>
  <BasePage :back-button="true" :pageTitle="pageTitle" show-menu show-footer>
    <Card title="Lessons" show-status-bar margin="">
      <div class="list-group list-group-flush">
        <router-link
            v-for="lesson in lessons"
            :key="lesson.lessonTicketId"
            :to="`/registerLesson/${lesson.lessonRef}`"
            class="list-group-item list-group-item-action"
        >
          {{ lesson.lessonId }}
        </router-link>
        <div v-if="lessons.length === 0" class="text-center py-3 text-muted">
          {{ __DICT__.noLessons }}
        </div>
      </div>
    </Card>
  </BasePage>
</template>

<script setup>
import {ref, onMounted, computed} from "vue";
import { api } from "@/services/api.js";
import BasePage from "@/components/BasePage.vue";
import { useWeekStore} from "@/stores/week.js";
import { Card } from "@/components/atomic";

const props = defineProps({
  isWorkshop: {
    type: Boolean,
    default: false
  }
});

const pageTitle = computed( () => {
  if(props.isWorkshop){
    return __DICT__.actionMenu.registerWorkshop
  } else {
    return __DICT__.actionMenu.registerLesson
  }
})

const weekStore = useWeekStore()
const lessons = ref([]);

onMounted(async () => {
  let response = await api.get(`/api/workshopLessons/allLessons/${weekStore.weekId}`);
  let lessonType = props.isWorkshop ? "workshop" : "lesson";

  lessons.value = response.filter(lesson => lesson.lessonType === lessonType);
});
</script>